export const getRouteInstallerScheduleTable = () => "/installer-schedule";
export const getRouteInstallerScheduleHours = () => "/installer-schedule/hours";
export const getRouteInstallerSummarizedReport = () => "/installer-schedule/report";
export const getRouteInstallerEquipmentReport = () => "/installer-schedule/equipment";
